import { render, staticRenderFns } from "./UiDataGrid.vue?vue&type=template&id=5386ba44&"
import script from "./UiDataGrid.vue?vue&type=script&lang=js&"
export * from "./UiDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports